import { render, staticRenderFns } from "./Specializations.html?vue&type=template&id=0c79fe46&external"
import script from "./Specializations.js?vue&type=script&lang=js&external"
export * from "./Specializations.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports